import {CardActions} from "@mui/material"
import makeStyles from '@mui/styles/makeStyles';
import AddIcon from "@mui/icons-material/Add"
import React from "react"
import Button from "@mui/material/Button"
import {useBaseTranslation} from "../../../app/baseTranslationContext"

const useStyles = makeStyles(() => ({
    button: {
        marginLeft: "auto",
    },
}))

const UniqueSellingPoints = ({children, handleAddNewSellingPoint, addDisabled}) => {
    const classes = useStyles()
    const t = useBaseTranslation()

    return (
        <>
            {children}
            <CardActions>
                <Button variant="outlined"
                        color="primary"
                        disabled={addDisabled}
                        className={classes.button}
                        onClick={handleAddNewSellingPoint}
                        endIcon={<AddIcon/>}>
                    {t("add")}
                </Button>
            </CardActions>
        </>
    )
}

export default UniqueSellingPoints
